import * as React from 'react';
import { SortOrder } from 'antd/lib/table/interface';
import { withTranslation, WithTranslation } from 'react-i18next';
import { I18N_NS } from 'Config/i18n';

interface TableColumnHeaderProps extends WithTranslation {
  title: string;
  sortOrder: SortOrder;
}

export const TableColumnHeader = withTranslation(I18N_NS.ADMIN)(
  class extends React.Component<TableColumnHeaderProps> {

    private sort: { [key in SortOrder]: string } = {
      descend: 'Sort descending',
      ascend: 'Sort ascending'
    };

    render() {
      const { sortOrder, title, t } = this.props;
      return (
        <div title={t(this.sort[sortOrder])}>{title}</div>
      );
    }
  }
);